var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert alert-primary alert-dismissible fade show",attrs:{"role":"alert"}},[_c('a',{staticClass:"mr-auto",attrs:{"href":_vm.file,"target":"_blank"}},[_c('i',{staticClass:"ic-file"}),_vm._v(" File ")]),_c('span',[_c('i',{staticClass:"ic-close close",on:{"click":_vm.clearUploadedFile}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }